<template>
  <div class="width-240 chat-contacts">
    <template v-if="membersList.length">
      <div class="chat-filter">
        <input type="text" v-model="filterName">
      </div>
      <div class="chat-members">
        <ul class="clear-gaps">
          <li class="chat-contact-member"
              v-for="member in filteredList"
              :class="{'active-item':activeIdx===member.peerId}"
              :key="member.peerId"
              @click="onSelectMember(member)">
            {{member.name || member.peerId}}
          </li>
        </ul>
      </div>
    </template>
    <div v-else class="chat-none-member">暂无咨询</div>
  </div>
</template>

<script>
import {getMemberMetaInfo, getMemberName} from '@/http';

export default {
  name: 'ImManagerContact',
  props: {
    companiesObj: Object,
  },
  data() {
    return {
      activeIdx: null,
      filterName: '',
    };
  },
  computed: {
    filteredList({membersList, filterName}){
      return membersList.filter(m => m.name.indexOf(filterName) >= 0);
    },
    membersList({companiesObj}) {
      const companiesArr = [];
      if (companiesObj) {
        Object.keys(companiesObj).forEach(peerId => {
          const {meta, list} = companiesObj[peerId], len = list.length;
          const last = len ? list[len - 1] : {text: null, formatted: null, time: 0};
          const memberName = meta.name || getMemberName(peerId) || '';
          const item = {
            peerId,
            name: memberName,
            lastMsg: last.text,
            time: last.time,
            lastFormatted: last.formatted,
          };
          if (memberName) {
            getMemberMetaInfo(peerId).then(name => {
              item.name = name;
              this.$forceUpdate();
            });
          }
          companiesArr.push(item);
        });
        return companiesArr.sort((i1, i2) => i2.time - i1.time);
      }
      return companiesArr;
    },
  },
  methods: {
    onSelectMember(member) {
      this.activeIdx = member.peerId;
      this.$emit('select', member.peerId, member);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-contacts {
  width: 240px;
  display: flex;
  flex-direction: column;
  background: #F2F2F2;

  & > .chat-filter {
    padding: 10px 10px 5px;
    box-sizing: border-box;

    & > input {
      padding: 0 8px;
      width: 100%;
      line-height: 24px;
      box-sizing: border-box;
      border: 1px solid #AAA;
      outline: none;
      background: transparent;
      border-radius: 3px;
      transition-duration: .2s;

      &:focus {
        background: #FFF;
      }
    }
  }

  & > .chat-members {
    flex: 1;
    padding: 5px 0 15px;
    overflow: hidden;
    box-sizing: border-box;

    &:hover {
      overflow: auto;
    }
  }

  & .chat-contact-member {
    list-style: none;
    line-height: 42px;
    box-sizing: border-box;
    padding: 0 10px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    transition-duration: .2s;
    background: transparent;

    &:hover {
      background: #e2e2e2;
    }

    &:active, &.active-item {
      background: #d2d2d2;
    }
  }
}

.chat-none-member {
  line-height: 64px;
  text-align: center;
}

.clear-gaps {
  margin: 0;
  padding: 0;
}
</style>